<template>
    <div>
        <v-row>
            <v-col cols="8">
                <v-text-field
                    v-model="$store.state.cp.searchString"
                    label="Søg"
                    clearable
                    solo
                    prepend-inner-icon="fa-search"
                    hide-details
                />
            </v-col>
            <v-col cols="4">
                <v-card>
                    <v-tabs grow v-model="$store.state.cp.department">
                        <v-tab>Tryg</v-tab>
                        <v-tab>Alka</v-tab>
                    </v-tabs>
                </v-card>
            </v-col>
        </v-row>
        <loader v-if="loading" />
        <v-row v-else>
            <v-col cols="12">
                <v-card>
                    <v-list class="collapsed-inputs striped-list">
                        <v-list-item dense inactive v-for="user in paginatedUsers" :key="user.name">
                            <v-list-item-content>
                                <v-col cols="4" class="d-flex justify-start align-center">
                                    {{ user.name }}
                                </v-col>
                                <v-col cols="7" class="d-flex justify-end align-center">
                                    <v-btn
                                        class="mx-1"
                                        :color="(level => {if (!levels.includes(level)) return 'primary'})(user.level)"
                                        @click="user.level = -1; updateUserSetting(user)"
                                    >
                                        X
                                    </v-btn>
                                    <v-btn
                                        v-for="(btnLevel, index) in levels"
                                        :key="'b' + index"
                                        class="mx-1"
                                        :color="activeButton(user.level, btnLevel)"
                                        @click="user.level = btnLevel; updateUserSetting(user)"
                                    >
                                        <span v-if="btnLevel === 0">OB</span>
                                        <span v-else>{{ btnLevel }}</span>
                                    </v-btn>
                                </v-col>
                                <v-col cols="1" class="text-right">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{on, attrs}">
                                            <v-btn fab x-small color="primary" v-bind="attrs" v-on="on" @click="handleClickAddCampaigns(user)">
                                                <v-icon>
                                                    fa-plus
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Tilføj kampagnerettigheder</span>
                                    </v-tooltip>
                                </v-col>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-row v-if="filteredUsers.length > itemsPerPage">
                        <v-col>
                            <v-pagination v-model="page" :length="Math.ceil(filteredUsers.length / itemsPerPage)" />
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="showAddCampaignsDialog" width="900" v-if="selectedUser">
            <v-card>
                <v-card-title>Rediger kampagnerettigheder for "{{ selectedUser.name }}"</v-card-title>
                <v-divider></v-divider>
                <v-card-text v-if="loadingCampaigns"><loader /></v-card-text>
                <v-card-text v-else>
                    <v-row>
                        <v-col>
                            <v-text-field
                                append-icon="fa-search"
                                single-line
                                label="Søg"
                                outlined
                                hide-details
                                v-model="searchString"
                                clearable
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-subheader>Alle kampagner</v-subheader>
                            <v-divider></v-divider>
                            <v-card-text v-if="!availableCampaigns.length">Ingen kampagner matcher din søgning</v-card-text>
                            <v-list v-else>
                                <v-virtual-scroll :items="availableCampaigns" :item-height="50" height="250">
                                    <template v-slot="{ item }">
                                        <v-list-item @click="addCampaign(item.uniqueId)">
                                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                                        </v-list-item>
                                        <v-divider></v-divider>
                                    </template>
                                </v-virtual-scroll>
                            </v-list>
                        </v-col>
                        <v-col>
                            <v-subheader>Valgte kampagner</v-subheader>
                            <v-divider></v-divider>
                            <v-card-text v-if="!selectedCampaigns.length">Du har ikke valgt nogen kampagner</v-card-text>
                            <v-card-text v-else-if="!filteredSelectedCampaigns.length">Ingen af de valgte kampagner matcher din søgning</v-card-text>
                            <v-list v-else>
                                <v-virtual-scroll :items="filteredSelectedCampaigns" :item-height="50" height="250">
                                    <template slot-scope="props">
                                        <v-list-item @click="removeCampaign(props.item.uniqueId)" :key="props.itemKey">
                                            <v-list-item-title>{{ props.item.name }}</v-list-item-title>
                                        </v-list-item>
                                        <v-divider></v-divider>
                                    </template>
                                </v-virtual-scroll>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn class="red--text" text @click="showAddCampaignsDialog = false">Annuller</v-btn>
                    <v-btn class="green--text" text @click="updateCampaigns" :loading="submitting">Gem ændringer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data () {
        return {
            levelTab: 0,
            loading: true,
            submitting: false,
            loadingCampaigns: true,
            users: null,
            page: 1,
            itemsPerPage: 7,
            showAddCampaignsDialog: false,
            selectedUser: null,
            selectedCampaigns: [],
            searchString: ''
        }
    },
    computed: {
        availableCampaigns () {
            return this.$store.getters['main/getCampaigns'].filter(campaign => {
                const matchesSearch = !this.searchString || campaign.name.replace(/[_\s]/gi, '').toLowerCase().includes(this.searchString.replace(/[_\s]/gi, '').toLowerCase())
                const selected = this.selectedCampaigns.includes(campaign.uniqueId)
                return matchesSearch && !selected
            })
        },
        filteredSelectedCampaigns () {
            return this.$store.getters['main/getCampaigns'].filter(campaign => {
                const matchesSearch = !this.searchString || campaign.name.replace(/[_\s]/gi, '').toLowerCase().includes(this.searchString.replace(/[_\s]/gi, '').toLowerCase())
                const selected = this.selectedCampaigns.includes(campaign.uniqueId)
                return matchesSearch && selected
            })
        },
        levels() {
            return this.$store.state.cp.levels[this.department]
        },
		department() {
			return this.$store.getters['cp/department']
        },
        departments() {
            return this.$store.state.cp.departments
        },
        filteredUsers () {
            return [...this.users].sort((a, b) => {
                if (!this.levels.includes(b.level)) return -1
                return a.level > b.level ? -1 : 1
            })
            .filter(item => {
                return this.$store.state.cp.searchString
                ? item.name.replace(/[_\s]/gi, '').toLowerCase().includes(this.$store.state.cp.searchString.replace(/[_\s]/gi, '').toLowerCase())
                : true
            })
        },
        paginatedUsers () {
            return [...this.filteredUsers].splice(this.itemsPerPage * (this.page - 1), this.itemsPerPage)
        }
	},
    methods: {
        async updateCampaigns () {
            this.submitting = true
            await this.$http().put('controlpanel/agents/campaignAccess', {
                uniqueId: this.selectedUser.uniqueId,
                campaigns: this.selectedCampaigns
            })
            this.submitting = false
            this.showAddCampaignsDialog = false
            this.searchString = ''
        },
        addCampaign (uniqueId) {
            this.selectedCampaigns.push(uniqueId)
        },
        removeCampaign (uniqueId) {
            this.selectedCampaigns.splice(this.selectedCampaigns.indexOf(uniqueId), 1)
        },
        async handleClickAddCampaigns (user) {
            this.showAddCampaignsDialog = true
            this.selectedUser = user
            this.loadingCampaigns = true
            const response = await this.$http().get('controlpanel/agents/campaignAccess', {
                params: {
                    uniqueId: user.uniqueId
                }
            })
            this.selectedCampaigns = response.data
            this.loadingCampaigns = false
        },
        async updateUserSetting (user) {
			await this.$http().patch('/controlpanel/agents/userSetting', {
                ...user,
                id: user.settingsId
            })
        },
        async getData() {
            this.loading = true
            let response = await this.$http().get('/controlpanel/agents', {
                params: {
                    department: this.department
                }
            })
            this.users = response.data
            this.loading = false
        },
        activeButton(level, btnLevel) {
            if (level === btnLevel) return 'primary'
        }
    },
    watch: {
        department: function () {
            this.getData()
        },
        showAddCampaignsDialog: function () {
            if (this.showAddCampaignsDialog === false) {
                this.selectedUser = null
                this.selectedCampaigns = []
            }
        }
    },
    async created () {
        this.$store.state.cp.searchString = null
        await this.getData()
    }
}
</script>